import api from '~/services/api';
import { DerivadosProps, tipoAjusteProps } from '../../types';

const getTiposDeAjuste = async (): Promise<{
  data: {
    rowsSaida: tipoAjusteProps[];
    rowsEntrada: tipoAjusteProps[];
  };
  success: boolean;
}> => {
  const { data } = await api.get('/tipoajusteestoque/tipos-de-para');
  return data;
};

const getProdDerivados = async (
  cod_loja: number,
  cod_produto: string,
): Promise<{
  data: DerivadosProps[];
  success: boolean;
}> => {
  const { data } = await api.get(
    `/produto-derivado/${cod_loja}/${cod_produto}`,
  );
  return data;
};

export const getInfos = { getTiposDeAjuste, getProdDerivados };
